import React from 'react';
import { useSocket } from '../hooks/useSocket';
import { useTokenLifecycle } from '../hooks/useTokenLifecycle';

const SocketManager: React.FC = () => {
  useSocket();
  useTokenLifecycle();

  // Логирование состояния подключения
  // React.useEffect(() => {
  //   if (isAuthenticated) {
  //     if (isConnecting) {
  //       console.log('🔄 Socket.IO: Подключение...');
  //     } else if (isConnected) {
  //       console.log('✅ Socket.IO: Подключен и готов к работе');
  //     } else if (connectionError) {
  //       console.error('❌ Socket.IO: Ошибка подключения:', connectionError);
  //     }
  //   } else {
  //     console.log('🔒 Socket.IO: Пользователь не авторизован, подключение недоступно');
  //   }
  // }, [isConnected, isConnecting, connectionError, isAuthenticated]);

  // Этот компонент не рендерит ничего видимого, только управляет Socket.IO
  return null;
};

export default SocketManager;
